import { render, staticRenderFns } from "./PurchaseOrderSideMenu.vue?vue&type=template&id=2fd080d7&scoped=true"
import script from "./PurchaseOrderSideMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderSideMenu.vue?vue&type=style&index=0&id=2fd080d7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd080d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd080d7')) {
      api.createRecord('2fd080d7', component.options)
    } else {
      api.reload('2fd080d7', component.options)
    }
    module.hot.accept("./PurchaseOrderSideMenu.vue?vue&type=template&id=2fd080d7&scoped=true", function () {
      api.rerender('2fd080d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderSideMenu.vue"
export default component.exports